


















import { UiIconButton, UiTextbox } from './keen-ui';

export default {
  name: 'editable-label',
  props: {
    value: String,
    handleEditable: {
      type: Boolean,
      default: true
    },
    editable: Boolean,
    invalid: Boolean,
    disabled: Boolean
  },
  components: {
    UiTextbox,
    UiIconButton
  },
  methods: {
    onTextboxChange: function (): void {
      const inputEl = (this.$refs.textbox.$refs.input as HTMLInputElement);
      this.$emit('input', inputEl.value);
      if (this.handleEditable) {
        this.$emit('updateEditable', false);
      }
    },
    onTextboxBlur: function (): void {
      if (this.handleEditable) {
        this.$emit('updateEditable', false);
      }
    }
  },
  watch: {
    editable: function (editable: boolean): void {
      if (this.handleEditable && editable) {
        this.$nextTick(() => {
          this.$refs.textbox.focus();
        });
      }
    }
  }
};

